import {useContext} from 'react';

import {TranslatableResourceSearchContext} from '../context';

export function useSearch() {
  const context = useContext(TranslatableResourceSearchContext);

  if (!context) {
    throw new Error(
      'useSearch must be used inside a TranslatableResourceSearchProvider',
    );
  }

  return context;
}
